//  Node imports
import { ingenuity, ISpineData, SpineBase, IEvent, EventConstants, dispatcher, BaseCoreEventConstants, Loading, base } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-leopard/dist";

export class StackSymbolFeatureViewFG extends BaseViewBehavior {

  /** Resize */
  protected resize(evt: IEvent): void {
    if (!ingenuity.deviceEnv.isDesktop) {
      if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
        this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
        this.updateOrientation();
      }
    }
  }

  /**
   * method getSpineJsonAndCloneSym: clone spine animation
   */
  public getSpineJsonAndCloneSym(): SpineBase { 
    let stackSpineJsonObj: ISpineData = this.json["hp_chara"];
    stackSpineJsonObj.type = "spine";
    let stackSpineCloneAnim: SpineBase = this.createSpine(stackSpineJsonObj);
    stackSpineCloneAnim.visible = false;
    return stackSpineCloneAnim;
  }

  /**
   * to clone spine
   */
  public getStackTransitionClone(): SpineBase {
    let stackSpineJsonObj: ISpineData = this.json["stack_effect"];
    stackSpineJsonObj.type = "spine";
    let stackSpineCloneAnim: SpineBase = this.createSpine(stackSpineJsonObj);
    stackSpineCloneAnim.visible = false;
    return stackSpineCloneAnim;
  }

  protected createSpine(json: ISpineData): SpineBase {
    if (Loading.isSpineLoaded(json.image)) {
      //@ts-expect-error
      const spine = new base.Spine(json);
      if (json.parent) {
        this.containers[json.parent].addChild(spine);
      } else {
        this.addChild(spine);
      }
      json.key = json.key ? json.key : json.id;
      this.spines[json.key] = spine;
      this.allComponents[json.id] = spine;
      dispatcher.fireEvent(EventConstants.COMPONENT_CREATED, spine);
      return spine;
    } else {
      dispatcher.on(BaseCoreEventConstants.FILE_LOADED, (evt) => {
        if (
          (evt.data === json.image || evt.data === json.image + ".png" || evt.data === json.image + ".webp") &&
          Loading.isImageLoaded(evt.data)
        ) {
          evt.remove();
          // adding delay so that the currentGame.cache.spine has the entry of the loaded spine, if it is not in cache it does not create the spine and we do not have
          // any event as of now by which we can check if the spine is loaded in the cache after the files are loaded fileLoadComplete on our loader is called before fileLoadComplete of Spine
          // utils.delayedCall(core.base.constants.delayKeys.SPINE_CREATION_DELAY, 1, (jsonArray: ISpineData[]) => {
          this.createSpine(json);
          // }, this, json);
        }
      });
    }
  }
}
